import React from 'react';
import { useLangue } from '../i18n/LangueContext';

const BlocContact = ({ sujet, corps }) => {
  const { t } = useLangue();

  const lien = (adresse) => {
    const params = [];
    if (sujet) params.push(`subject=${encodeURIComponent(sujet)}`);
    if (corps) params.push(`body=${encodeURIComponent(corps)}`);
    return `mailto:${adresse}${params.length ? `?${params.join('&')}` : ''}`;
  };

  return (
    <div className="bloc-contact">
      <p className="chapeau">{t.contact.intro}</p>
      <p className="invite-contact">{t.contact.invite}</p>
      <div className="adresses">
        {t.contact.adresses.map((a) => (
          <a key={a} className="carte-adresse" href={lien(a)}>
            <span className="eti-adresse">{t.contact.ecrire}</span>
            <span className="valeur-adresse">{a}</span>
          </a>
        ))}
      </div>
      <p className="cloture-contact">{t.contact.cloture}</p>
    </div>
  );
};

export default BlocContact;
